<h2 class="eb-consent-management__page-header">{{ 'consentManagement.title' | cxTranslate }}</h2>

<ng-container *ngIf="templateList$ | async as templateList; else spinner">
  <eb-consent-management-form
    *ngFor="let consentTemplate of templateList"
    [consentTemplate]="consentTemplate"
    [requiredConsents]="requiredConsents"
    (consentChanged)="onConsentChange($event)"
  ></eb-consent-management-form>
</ng-container>

<ng-template #spinner>
  <eb-spinner *ngIf="loading$ | async"></eb-spinner>
</ng-template>
